module.exports = __webpack_public_path__ + "img/for.7f2cfb4b.svg";